// libs
import React from "react";
import Icon from "@ant-design/icons";

const MyDailyReportSvg = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.66667 17.1H13.3333C14.3072 17.1 15.1 16.3072 15.1 15.3333V2.66667C15.1 1.69277 14.3072 0.9 13.3333 0.9H4.66667C3.69277 0.9 2.9 1.69277 2.9 2.66667V15.3333C2.9 16.3072 3.69277 17.1 4.66667 17.1ZM3.76667 2.66667C3.76667 2.17056 4.17056 1.76667 4.66667 1.76667H13.3333C13.8294 1.76667 14.2333 2.17056 14.2333 2.66667V15.3333C14.2333 15.8294 13.8294 16.2333 13.3333 16.2333H4.66667C4.17056 16.2333 3.76667 15.8294 3.76667 15.3333V2.66667Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
    <path
      d="M5.33333 10.4334H12.6667C12.9059 10.4334 13.1 10.2393 13.1 10.0001C13.1 9.76085 12.9059 9.56675 12.6667 9.56675H5.33333C5.09411 9.56675 4.9 9.76085 4.9 10.0001C4.9 10.2393 5.09411 10.4334 5.33333 10.4334Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
    <path
      d="M5.33333 13.0999H12.6667C12.9059 13.0999 13.1 12.9058 13.1 12.6666C13.1 12.4274 12.9059 12.2333 12.6667 12.2333H5.33333C5.09411 12.2333 4.9 12.4274 4.9 12.6666C4.9 12.9058 5.09411 13.0999 5.33333 13.0999Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
    <path
      d="M5.33333 7.76667H12.6667C12.9059 7.76667 13.1 7.57256 13.1 7.33333C13.1 7.09411 12.9059 6.9 12.6667 6.9H5.33333C5.0941 6.9 4.9 7.09411 4.9 7.33333C4.9 7.57256 5.0941 7.76667 5.33333 7.76667Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
    <path
      d="M5.33333 5.09992H9.33333C9.57256 5.09992 9.76667 4.90582 9.76667 4.66659C9.76667 4.42736 9.57256 4.23325 9.33333 4.23325H5.33333C5.0941 4.23325 4.9 4.42736 4.9 4.66659C4.9 4.90582 5.0941 5.09992 5.33333 5.09992Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
  </svg>
);

const MyDailyReportIcon = (props) => (
  <Icon component={MyDailyReportSvg} {...props} />
);

export default MyDailyReportIcon;
